var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('TheTitle',[_vm._v("U Lifestyle 社群")]),_c('AdvList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }